<template>
  <ContextMenu :id="id" :items="menu" align="right" />
</template>

<script>
import ContextMenuMixin from "mixins/ContextMenu";
export default {
  mixins: [ContextMenuMixin],
  computed: {
    routeParam() {
      return { submission: this.item.id };
    },
    menu() {
      return [
        {
          label: "Edit",
          action: () => {
            this.goToRoute("admin.surveys.submissions.edit", this.routeParam);
          },
        },
        {
          label: "Remove",
          action: () => {
            this.delete("remove");
          },
        },
      ];
    },
  },
  methods: {
    delete(item) {
      if (confirm(`Are you sure you would like to remove this submission?`)) {
        this.axios
          .delete(
            this.route("admin.surveys.submissions.destroy", this.routeParam)
          )
          .then(() => {
            this.eventBus.$emit("refresh");
            this.$emit(
              "show-alert",
              "success",
              "The submission has been removed",
              true
            );
          });
      }
    },
  },
};
</script>